// src/services/chitalishteAdminService.js
import api from './api';

const chitalishteAdminService = {
  getAllChitalishta: async (params = { page: 0, size: 12, sortBy: 'name', sortDirection: 'asc' }) => {
    const response = await api.get('/admin/chitalishta', { params });
    return response.data;
  },

  getChitalishteById: async (id) => {
    const response = await api.get(`/chitalishta/${id}`);
    return response.data;
  },

  createChitalishte: async (data, feedbackId = null) => {
    const params = feedbackId ? { feedbackId } : {};
    const response = await api.post('/admin/chitalishta', data, { params });
    return response.data;
  },

  updateChitalishte: async (id, data, feedbackId = null) => {
    const params = feedbackId ? { feedbackId } : {};
    const response = await api.put(`/admin/chitalishta/${id}`, data, { params });
    return response.data;
  },

  deleteChitalishte: async (id, feedbackId = null) => {
    const params = feedbackId ? { feedbackId } : {};
    await api.delete(`/admin/chitalishta/${id}`, { params });
    return id;
  },

  searchChitalishta: async (params) => {
    const response = await api.get('/chitalishta/search', { params });
    return response.data;
  },

  getTotalCount: async () => {
    const response = await api.get('/chitalishta/count');
    return response.data;
  },

  getInformationCardsByChitalishte: async (chitalishteId) => {
    const response = await api.get(`/admin/chitalishta/${chitalishteId}/information-cards`);
    return response.data;
  },

  getAllInformationCards: async () => {
    const response = await api.get('/admin/chitalishta/information-cards/all');
    return response.data;
  },

  getInformationCardById: async (id) => {
    const response = await api.get(`/chitalishta/information-cards/${id}`);
    return response.data;
  },

  createInformationCard: async (data, feedbackId = null) => {
    const { chitalishteId, ...cardData } = data;
    const params = feedbackId ? { feedbackId } : {};
    const response = await api.post(`/admin/chitalishta/${chitalishteId}/information-cards`, cardData, { params });
    return response.data;
  },

  updateInformationCard: async (id, data, feedbackId = null) => {
    const { chitalishteId, ...cardData } = data;
    const params = feedbackId ? { feedbackId } : {};
    const response = await api.put(`/admin/chitalishta/information-cards/${id}`, cardData, { params });
    return response.data;
  },

  deleteInformationCard: async (id, feedbackId = null) => {
    const params = feedbackId ? { feedbackId } : {};
    await api.delete(`/admin/chitalishta/information-cards/${id}`, { params });
    return id;
  }
};

export default chitalishteAdminService;